<div>
  @if(isLoading) {
  <app-loading-indicator />
  } @else {
  <div class="control-row">
    <div class="control mx-5">
      <label class="mb-1" for="selectProgram" style="font-weight: bold; color: #719eb6"
        >Selected Program:</label
      >
      <p-dropdown
        id="selectProgram"
        appendTo="body"
        autoWidth="false"
        styleClass="w-100 mb-3"
        [style]="{ width: '100%' }"
        [panelStyle]="programDropdownPanelStyle"
        [options]="selectablePrograms()"
        [(ngModel)]="selectedProgram"
        name="selectedProgram"
        [checkmark]="true"
        optionLabel="label"
        optionValue="value"
        [showClear]="true"
        placeholder="Select Program"
        [filter]="true"
        filterBy="label"
        display="chip"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="50"
        [loading]="isLoading"
        [disabled]="isLoading"
        (onShow)="syncProgramDropdownPanelWidth()"
        (onChange)="onProgramsChange($event)"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption>
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.label }}</div>
          </div>
        </ng-template>
        <ng-template pTemplate="item" let-option>
          <div class="flex align-items-center gap-2">
            <div>{{ option.label }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>
  @for (program of selectedProgramGraphHosts(); track program.ID) {
  <app-program-graph
    [patientID]="patientID()"
    [selectedProgram]="program"
  ></app-program-graph>
  }
  }
</div>
